import React from "react";
import {
  Box,
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Button,
  Avatar,
  Container,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  TextareaAutosize,
  Stack,
  Divider,
  Autocomplete,
} from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import RecepcionDialog from "./recepciondialog";
import { useState, useEffect } from "react";
import { StyledCellHeader } from "../../../../components/StyledCellHeader";
import OnGeneralMessageDialog from "../../../../components/Dialogs/OnGeneralMessageDialog";
import { useNavigate } from "react-router-dom";
import AccessDeniedBox from '../../../../components/AccessDeniedBox';
import EmptyState from '../../../../components/EmptyState';
import { LocalShipping, TrendingUp, Assessment, Inventory } from '@mui/icons-material';

export default function RecepcionOrdenCompra() {
  // Placeholders para los datos. Puedes reemplazar por estados/hook/api
  const navigate = useNavigate();
  const [ordenCompraSeleccionada, setOrdenCompraSeleccionada] = useState(null);
  const [openGeneralMessageDialog, setOpenGeneralMessageDialog] = useState(false);

  const [openRecepcionDialog, setOpenRecepcionDialog] = useState(false);
  const [ordenescompra, setOrdenesCompra] = useState([]);
  const [recepciones, setRecepciones] = useState([]);
  const [productos, setProductos] = useState([]);
  const [productosPendientes, setProductosPendientes] = useState([]);
  const [accessDenied, setAccessDenied] = useState(false);
  useEffect(() => {
    fetch(process.env.REACT_APP_SERVER_URL+'/api/ordenes-compra/'+localStorage.getItem('idcompany'), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany'), 
      },
    }).then((response) => response.json()).then((data) => {
      if(data["error"]!="Acceso denegado"){
        setAccessDenied(false);
        setOrdenesCompra(data);
      }else{
        setAccessDenied(true);
      }
    });
  }, []);


  async function getOrdenCompra(id){
    const response = await fetch(process.env.REACT_APP_SERVER_URL+'/api/ordenes-compra/detalle/'+id, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany'),
      },
    });
    const data = await response.json();
    setRecepciones(data.recepciones);
    setProductos(data.detalles);

    const recibidasPorProducto = {};
    if (data.recepciones && Array.isArray(data.recepciones)) {
      data.recepciones.forEach((rec) => {
        const idProd = rec.id_producto;
        const cantidad = parseFloat(rec.cantidad_recibida) || 0;
        if (!recibidasPorProducto[idProd]) {
          recibidasPorProducto[idProd] = 0;
        }
        recibidasPorProducto[idProd] += cantidad;
      });
    }

    const pendientes = [];
    if (data.detalles && Array.isArray(data.detalles)) {
      data.detalles.forEach((prod) => {
        const idProd = prod.id_producto || prod.id;
        const cantidadOrdenada = parseFloat(prod.cantidad) || 0;
        const cantidadRecibida = recibidasPorProducto[idProd] || 0;
        const cantidadPendiente = cantidadOrdenada - cantidadRecibida;
        if (cantidadPendiente > 0) {
          pendientes.push({
            ...prod,
            cantidadPendiente,
            cantidadRecibida,
          });
        }
      });
    }
    setProductosPendientes(pendientes);



  }

  const handleUpdateOrdenCompra = () => {
    getOrdenCompra(ordenCompraSeleccionada.id);
  }

  const handleRegisterFactura = () => {
    setOpenGeneralMessageDialog(true);
  }

  return (
    <Box minHeight="100vh" bgcolor="white" sx={{ fontFamily: '"Inter", "Noto Sans", sans-serif' }}>
      <OnGeneralMessageDialog open={openGeneralMessageDialog} onClose={()=>{setOpenGeneralMessageDialog(false)}} title={"Orden de Compra Recibida"} message={"Deseas registrar la factura de la orden de compra?"} buttonText={"Registrar Factura"} onRegister={()=>{navigate("/logistica/compras/facturas-proveedor/crear")}}/>
      <Container maxWidth={false} sx={{ px: 10, py: 5 }}>
        <Box maxWidth={960} mx="auto" display="flex" flexDirection="column" gap={3}>
          {/* Header y resumen */}
          {!accessDenied ? 
          <Paper elevation={1} sx={{ p: 3, display: "flex", gap: 4, alignItems: "stretch", borderRadius: 1 }}>
            <Box flex={2} textAlign={"left"}>
              <Autocomplete
                options={ordenescompra}
                onChange={(event, value) => {
//                  alert(JSON.stringify(value));
                  setOrdenCompraSeleccionada(value);
                  if(value){
                    getOrdenCompra(value.id);
                  }
                }}
                getOptionLabel={(option) => {return "Orden # "+option.numero_orden+" | "+option.proveedor_name+" | "+option.rnc}}
                renderInput={(params) => <TextField {...params} placeholder="Orden de Compra" />}
              />
              {ordenCompraSeleccionada ? (
                <>
                <Typography fontWeight="bold" color="#111518" mb={0.5} mt={1}>
                  Resumen de la Orden
                </Typography>
                <Typography color="#617689" fontSize={14}>
                  Proveedor: {ordenCompraSeleccionada.proveedor_name} | RNC: {ordenCompraSeleccionada.rnc} | Fecha:{ordenCompraSeleccionada.fecha_emision} | Almacen: {ordenCompraSeleccionada.almacen_name} | Total: ${ordenCompraSeleccionada.total_estimado}
                </Typography>
                </>
                ):
                ordenescompra.length === 0 ? (
                  <EmptyState 
                    icon={LocalShipping}
                    title="No hay órdenes de compra disponibles"
                    description="No se encontraron órdenes de compra para gestionar recepciones. Crea una orden de compra primero para poder registrar las recepciones de productos."
                    features={[
                        {
                            icon: Inventory,
                            title: "Control de Inventario",
                            description: "Gestión completa de recepciones y stock"
                        },
                        {
                            icon: TrendingUp,
                            title: "Seguimiento de Entregas",
                            description: "Monitoreo de productos recibidos"
                        },
                        {
                            icon: Assessment,
                            title: "Reportes de Recepción",
                            description: "Análisis de entregas y proveedores"
                        }
                    ]}
                    buttonText="Crear Orden de Compra"
                    onButtonClick={() => navigate('/logistica/compras/ordenes-compra/crear')}
                    helpText="¿Necesitas ayuda? Contacta a soporte técnico para guiarte en el proceso"
                  />
                ) : (
                  <Typography fontWeight="bold" color="#111518" mb={5} mt={1} textAlign={"center"}>
                    Seleccione una orden de compra
                  </Typography>
                )
                }
            </Box>
            <Box
              flex={1}
              sx={{
                minWidth: 160,
                minHeight: 120,
                borderRadius: 3,
                background: "center / cover no-repeat url('https://lh3.googleusercontent.com/aida-public/AB6AXuC1NvqDwdjRqMGrSmDA3s0ryyGVhhjH59KrAJ_xeyaDbKln30PhKSyZ6dR-1QG_3uKtxyF_2_eh60fcxLqBZHv2wIgD2tZ425pHN6qemQzH3I8C58Sf9AtBFLmvK4JfdPkSrRNtHFHeKFMApYpIm3g7gcW8bLeyEs16qXXwLtyIWML1VTaEXALxyCbU1LCKt9Djoe3m_mshSdyAT9IIVeXZjOYW4HRqFz2hARpe66HfMDXA8Re4GCGH0YWvLx-LpVkn0R7S5LtRoj-j')",
              }}
            ></Box>
          </Paper>
          :
          <Box>
            <br></br>
            <br></br>
            <AccessDeniedBox
              title={'Acceso denegado'}
              message={'No tienes permisos para ver esta sección de Recepción de Orden de Compra. Contacta a tu administrador para solicitar acceso o verifica tus roles y permisos.'}
            />
          </Box>
          }

          {/* Tabla de productos */}
          {ordenCompraSeleccionada && productosPendientes.length > 0 && (
          <>
            <Typography variant="h5" fontWeight="bold" color="#111518" px={2} pt={3} textAlign={"left"}>
              Productos Pendientes
            </Typography>
            {productosPendientes.length > 0 ? (
              <>
                <TableContainer component={Paper} sx={{ borderRadius: 3 }}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <StyledCellHeader>Producto</StyledCellHeader>
                        <StyledCellHeader>Cantidad Solicitada</StyledCellHeader>
                        <StyledCellHeader>Cantidad Recibida</StyledCellHeader>
                        <StyledCellHeader>Precio Unitario</StyledCellHeader>
                        <StyledCellHeader>Subtotal</StyledCellHeader>
                        <StyledCellHeader>ITBIS</StyledCellHeader>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {productosPendientes.map((row, idx) => (
                        <TableRow key={idx}>
                          <TableCell>{row.nombre}</TableCell>
                          <TableCell>{row.cantidad}</TableCell>
                          <TableCell>{row.cantidadRecibida}</TableCell>
                          <TableCell>{row.precio}</TableCell>
                          <TableCell>{row.subtotal}</TableCell>
                          <TableCell>{row.impuestos}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                <Box display="flex" justifyContent="flex-end" px={2} py={1}>
                  <Button variant="contained" color="primarybutton" sx={{ minWidth: 120, fontWeight: "bold" }} onClick={()=>{setOpenRecepcionDialog(true)}}>
                    Registrar Recepción
                  </Button>
                </Box>
              </>
            ) : (
              <EmptyState 
                icon={LocalShipping}
                title="Todos los productos han sido recibidos"
                description="Esta orden de compra ya ha sido completamente procesada. Todos los productos han sido recibidos y registrados en el sistema."
                features={[
                    {
                        icon: Inventory,
                        title: "Inventario Actualizado",
                        description: "Stock actualizado con productos recibidos"
                    },
                    {
                        icon: TrendingUp,
                        title: "Proceso Completado",
                        description: "Orden de compra procesada exitosamente"
                    },
                    {
                        icon: Assessment,
                        title: "Historial Disponible",
                        description: "Registro completo de recepciones"
                    }
                ]}
                buttonText="Ver Historial"
                onButtonClick={() => {/* Scroll to history section */}}
                helpText="Revisa el historial de recepción para ver todos los detalles"
              />
            )}
          </>
          )}

          {/* Historial de recepción */}
          {ordenCompraSeleccionada && (
          <>
            <Typography variant="h5" fontWeight="bold" color="#111518" px={2} pt={3} textAlign={"left"}>
              Historial de Recepción
            </Typography>
            <TableContainer component={Paper} sx={{ borderRadius: 3 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledCellHeader>Fecha</StyledCellHeader>
                    <StyledCellHeader>Usuario</StyledCellHeader>
                    <StyledCellHeader>Cantidad</StyledCellHeader>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {recepciones.map((row, idx) => (
                    <TableRow key={idx}>
                      <TableCell>{row.fecha}</TableCell>
                      <TableCell>{row.usuario_receptor}</TableCell>
                      <TableCell>{row.cantidad_recibida}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </>
          )}
        </Box>
      </Container>
      <RecepcionDialog open={openRecepcionDialog} onClose={()=>{setOpenRecepcionDialog(false)}} onRegister={handleRegisterFactura} onSubmit={handleUpdateOrdenCompra} productosPendientes={productosPendientes} productosRecibidos={recepciones}/>
    </Box>
  );
}
